import { formatDate, getCookie, simulateAsyncOperation, throttle } from "mmbclient/Common/CommonFunctions";
import { checkSession, getAllClients } from "mmbclient/Common/CommonService";
import { AD, All, API_PATH, APP_TYPE_COOKIE_NAME, EP, INVOICE_REPORT, LOGIN_COOKIE_NAME, LOGIN_COOKIE_NAME_SPLITBY, LOGIN_SESSION_NAME, LOGIN_THROTTLE_TIME, PAGE_LOADING_TIME, US, USER_TYPE_COOKIE_NAME } from "mmbclient/Common/CommonVariable";
import { RenderPagination } from "mmbclient/Components/RenderPagination";
import { useEffect, useState } from "react";
import * as XLSX from 'xlsx';

const InvoiceDetailController = (store) => {

    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState(new Date());
    const [option, setOption] = useState('');
    const [client, setClient] = useState("All");
    const [clientOption, setClientOption] = useState([]);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [itemPerPage , setItemPerPage] = useState(20);


    useEffect(() => {
        // Fetch data from server
        const fetchData = async () => {

            setLoading(true);
            try {
                if ((getCookie(USER_TYPE_COOKIE_NAME) === AD || getCookie(USER_TYPE_COOKIE_NAME) === EP)) {
                    await Promise.all([
                        loadAllClients(store),
                        simulateAsyncOperation(PAGE_LOADING_TIME),
                    ]);
                } else {
                    await Promise.all([
                        simulateAsyncOperation(PAGE_LOADING_TIME),
                    ]);
                }
            } catch (error) {
                console.log(error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    async function loadAllClients(store) {

        const response = await getAllClients(store);
        let lst_Client = [];
        lst_Client.push("All");
        if (response.length > 0) {
            let i;
            for (i of response) {
                lst_Client.push(i.client_name.toUpperCase() + " | " + i.client_code.toUpperCase());
            }
        }
        setClientOption(lst_Client);
        setClient(lst_Client[0]);
    }


    const loggerFunc = () => {
        checkSession(store);
    }

    const betterLoggerFunction = throttle(loggerFunc, LOGIN_THROTTLE_TIME);

    const handleSearch = async () => {

        // Check if the end date is earlier than the start date
        if (endDate < startDate) {
            alert("End date cannot be earlier than start date.");
            return;
        }

        checkSession(store);
        if (!getCookie(LOGIN_SESSION_NAME)) {
            return;
        }

        setLoading(true);

        try {
            const cookie = getCookie(LOGIN_COOKIE_NAME);
            const cookieUserType = getCookie(APP_TYPE_COOKIE_NAME);
            const c = cookie.split(LOGIN_COOKIE_NAME_SPLITBY);

            const Data = "Data";
            if (c.length === 4) {
                let query = {};
                if ((getCookie(USER_TYPE_COOKIE_NAME) === AD || getCookie(USER_TYPE_COOKIE_NAME) === EP)) {
                    if (client === All) {
                        query = { "userKey": c[0], "userType": cookieUserType, "bean": Data, "clientCode": client, "brnCode": All, "fromDate": startDate.toISOString().slice(0, 10), "toDate": endDate.toISOString().slice(0, 10) };
                    } else {
                        const clientCode = client.split("|")[1].trim();
                        query = { "userKey": c[0], "userType": cookieUserType, "bean": Data, "clientCode": clientCode, "brnCode": All, "fromDate": startDate.toISOString().slice(0, 10), "toDate": endDate.toISOString().slice(0, 10) };
                    }
                } else if (getCookie(USER_TYPE_COOKIE_NAME) === US) {
                    query = { "userKey": c[0], "userType": cookieUserType, "bean": Data, "clientCode": c[1], "brnCode": c[3], "fromDate": startDate.toISOString().slice(0, 10), "toDate": endDate.toISOString().slice(0, 10) };
                }
                const requestOptions = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: new URLSearchParams({
                        query: JSON.stringify(query)
                    })
                };
                const path = API_PATH + INVOICE_REPORT + "getinvoice";
                // console.log(query);
                // console.log(path);
                const res = await fetch(path, requestOptions)
                const data = await res.json();
                const response = JSON.parse(data)[0].Data;
                if (response.length > 0 && response !== "Result Not Found") {
                    setData(response);
                } else {
                    setData([]);
                }
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
        setLoading(false);
    };

    const escapeCsvValue = (value) => {
        if (typeof value === 'string') {
            // Replace commas, newlines, and carriage returns with semicolons
            value = value.replace(/[,]/g, ';')    // Replace commas with semicolons
                .replace(/[\n]/g, ';')   // Replace newlines with semicolons
                .replace(/[\r]/g, ';');  // Replace carriage returns with semicolons
            // Optionally, escape double quotes by replacing them with two double quotes
            value = value.replace(/"/g, '""');
        }
        return value;
    };

    const exportToCSV = () => {
        const csvRows = [];

        let headers;
        if ((getCookie(USER_TYPE_COOKIE_NAME) === AD || getCookie(USER_TYPE_COOKIE_NAME) === EP)) {
            headers = [
                'SNo',
                'Client',
                'Invoice No.',
                'Invoice Date',
                'From Date',
                'To Date',
                'GSTIN No.',
                'City',
                'Freight Amt',
                'Other',
                'Taxable Amt',
                'CGST',
                'SGST',
                'IGST',
                'Grand Total'
            ];
        } else {
            headers = [
                'SNo',
                'Invoice No.',
                'Invoice Date',
                'From Date',
                'To Date',
                'GSTIN No.',
                'City',
                'Freight Amt',
                'Other',
                'Taxable Amt',
                'CGST',
                'SGST',
                'IGST',
                'Grand Total'
            ];
        }

        csvRows.push(headers.join(',')); // Add headers

        if ((getCookie(USER_TYPE_COOKIE_NAME) === AD || getCookie(USER_TYPE_COOKIE_NAME) === EP)) {
            data.forEach((item, index) => {
                const values = [
                    escapeCsvValue(index + 1),
                    escapeCsvValue(item.client_name || ''),
                    escapeCsvValue(item.invoice_no || ''),
                    escapeCsvValue(formatDate(item.invoice_date) || ''),
                    escapeCsvValue(formatDate(item.from_date) || ''),
                    escapeCsvValue(formatDate(item.to_date) || ''),
                    escapeCsvValue(item.gstin_no || ''),
                    escapeCsvValue(item.city_name || ''),
                    escapeCsvValue(item.basic_amount || ''),
                    escapeCsvValue(item.other || ''),
                    escapeCsvValue(item.taxable_amount || ''),
                    escapeCsvValue(item.tax_amount1 || ''),
                    escapeCsvValue(item.tax_amount2 || ''),
                    escapeCsvValue(item.tax_amount3 || ''),
                    escapeCsvValue(item.grand_total || '')
                ];
                csvRows.push(values.join(',')); // Add data row
            });
        } else {
            data.forEach((item, index) => {
                const values = [
                    escapeCsvValue(index + 1),
                    escapeCsvValue(item.invoice_no || ''),
                    escapeCsvValue(formatDate(item.invoice_date) || ''),
                    escapeCsvValue(formatDate(item.from_date) || ''),
                    escapeCsvValue(formatDate(item.to_date) || ''),
                    escapeCsvValue(item.gstin_no || ''),
                    escapeCsvValue(item.city_name || ''),
                    escapeCsvValue(item.basic_amount || ''),
                    escapeCsvValue(item.other || ''),
                    escapeCsvValue(item.taxable_amount || ''),
                    escapeCsvValue(item.tax_amount1 || ''),
                    escapeCsvValue(item.tax_amount2 || ''),
                    escapeCsvValue(item.tax_amount3 || ''),
                    escapeCsvValue(item.grand_total || '')
                ];
                csvRows.push(values.join(',')); // Add data row
            });
        }

        const csvString = csvRows.join('\n');
        const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.setAttribute('href', url);
        link.setAttribute('download', 'data.csv');
        link.style.visibility = 'hidden';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };


    const exportToExcel = () => {
        if (Array.isArray(data) && data.length === 0) {
            alert("No data found");
            return;
        }

        setLoading(true);
        let ws;
        if ((getCookie(USER_TYPE_COOKIE_NAME) === AD || getCookie(USER_TYPE_COOKIE_NAME) === EP)) {
            ws = XLSX.utils.json_to_sheet(data.map((item, index) => ({
                SNo: index + 1,
                Client: item.client_name || '',
                'Invoice No.': item.invoice_no || '',
                'Invoice Date': formatDate(item.invoice_date) || '',
                'From Date': formatDate(item.from_date) || '',
                'To Date': formatDate(item.to_date) || '',
                'GSTIN No.': item.gstin_no || '',
                'City': item.city_name || '',
                'Freight': item.basic_amount || '',
                'Other': item.other || '',
                'Taxable Amt': item.taxable_amount || '',
                'CGST': item.tax_amount1 || '',
                'SGST': item.tax_amount2 || '',
                'IGST': item.tax_amount3 || '',
                'Grand Total': item.grand_total || ''
            })));
        } else {
            ws = XLSX.utils.json_to_sheet(data.map((item, index) => ({
                SNo: index + 1,
                'Invoice No.': item.invoice_no || '',
                'Invoice Date': formatDate(item.invoice_date) || '',
                'From Date': formatDate(item.from_date) || '',
                'To Date': formatDate(item.to_date) || '',
                'GSTIN No.': item.gstin_no || '',
                'City': item.city_name || '',
                'Freight': item.basic_amount || '',
                'Other': item.other || '',
                'Taxable Amt': item.taxable_amount || '',
                'CGST': item.tax_amount1 || '',
                'SGST': item.tax_amount2 || '',
                'IGST': item.tax_amount3 || '',
                'Grand Total': item.grand_total || ''
            })));
        }

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Data');

        XLSX.writeFile(wb, 'Data.xlsx');
        setLoading(false);
    };


    const [currentPage, setCurrentPage] = useState(1);
    const [searchTerm, setSearchTerm] = useState('');
    const itemsPerPage = itemPerPage;

    // Filter data based on search term
    const filteredData = data.filter(item => {

        const lowerCaseSearchTerm = searchTerm.toLowerCase();

        return (
            String(item?.client_name)?.toLowerCase().includes(lowerCaseSearchTerm) ||
            String(item?.invoice_no)?.toLowerCase().includes(lowerCaseSearchTerm) ||
            String(item?.invoice_date)?.toLowerCase().includes(lowerCaseSearchTerm) ||
            String(item?.from_date)?.toLowerCase().includes(lowerCaseSearchTerm) ||
            String(item?.to_date)?.toLowerCase().includes(lowerCaseSearchTerm) ||
            String(item?.gstin_no)?.toLowerCase().includes(lowerCaseSearchTerm) ||
            String(item?.grand_total)?.toLowerCase().includes(lowerCaseSearchTerm) ||
            String(item?.city_name)?.toLowerCase().includes(lowerCaseSearchTerm)
        );
    }
    );

    // Calculate total pages
    const totalPages = Math.ceil(filteredData.length / itemsPerPage);

    // Get current items
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

    return { searchTerm, setSearchTerm, setCurrentPage, currentItems, currentPage, totalPages, itemsPerPage, clientOption, client, setClient, loading, startDate, setStartDate, endDate, setEndDate, option, setOption, betterLoggerFunction, handleSearch, exportToCSV, exportToExcel, RenderPagination,setItemPerPage }
}

export default InvoiceDetailController;